var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mb-6", attrs: { "data-test": "tab-title" } },
    [
      _c("div", { staticClass: "flex justify-between" }, [
        _c(
          "h1",
          { staticClass: "text-xl mb-4", style: _vm.font },
          [_vm._t("default")],
          2
        ),
        _c(
          "button",
          {
            staticClass: "h-6 mt-1",
            attrs: {
              "data-test": "tab-title--close",
              title: _vm.$t(_vm.title.key, _vm.title.attr)
            },
            on: { click: _vm.close }
          },
          [_c("icon", { attrs: { type: "close", "aria-hidden": "true" } })],
          1
        )
      ]),
      _c("div", {
        staticClass: "border-dotted border-b-2 border-gray-400 w-full"
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }